export const CONFIG = {
    //Can use the other key when one key quota expires
    // googleMapsKey: "AIzaSyDXzrJuIrMpGM_19lrj8vHOR-DgSjH_-GA"
    // Manage the key here: https://console.cloud.google.com/apis/credentials/key/4b6f8b0d-1fc2-4002-8e49-34a60f4c238e?orgonly=true&project=log10-391705&supportedpurview=organizationId
    googleMapsKey: "AIzaSyDyvz9FykqsVlJbL-fRMi4BcSLW5yP6oW4"
};

